<template>
    <div class="buyNowMain" @click.self="removeDialog" v-if="ifShow">
        <div class="frame">
            <div class="shopName">店铺：{{ shopInfo.supplierInfo.name }}</div>

            <div class="pricePrompt">请输入核销金额：</div>

            <div class="priceInputWrapper">
                <input v-model="price" type="number" min="0.1" @blur="priceInputBlur"/>

                <div class="divider" />

                <div class="clearText" @click="price = ''">清除</div>
            </div>

            <button class="payButton" @click="payNow">立即支付</button>
        </div>
        <i class="iconfont icon-close2" style="color: #ffffff;font-size: 0.35rem;margin-top: 0.21rem;" @click="removeDialog"/>
    </div>
</template>

<script>

import {
    digitalCardPay,
} from "@/components/pay/digitalCard";
import createComponent from "#/createComponent.js";
import Login from "#/common_components/Login.vue";

import {
    mapState
} from "vuex";

export default {
    name: 'buyNow',

    props: {
        ifShow: {
            type: Boolean,
            required: true,
            default: false,
        },

        shopInfo: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapState({
            userInfo: state => state.auth.userInfo,
            defaultAddress: (state) => state.address.defaultAddress,
        }),
    },

    data()
    {
        return {
            price: "1",
        }
    },

    created()
    {
        if(!this.userInfo || !this.userInfo.mobile || this.userInfo.mobile == "")
        {
            // popup mode, and current path is not login
            if (document.getElementById("loginPopup") == null && 
                window.location.href.substring(window.location.href.length - '#/login'.length) != '#/login' &&
                window.location.href.indexOf('#/login?') < 0) {
                createComponent(Login, {
                    on: {
                        loginSuccess() {
                            window.location.reload();
                        },
                    },
                });
            }
        }
    },

    methods: {
        removeDialog() {
            this.$emit('update:ifShow', false)
        },

        priceInputBlur()
        {
            
        },

        payNow() {
            if(this.price == "")
            {
                return this.Toast("价格不能为空");
            }

            const dotPosition = this.price.indexOf(".")
            if(dotPosition >= 0 && this.price.substring(dotPosition + 1).length > 1)
            {
                return this.Toast("价格有误, 最小单位为一角");
            }

            if(!this.userInfo || !this.userInfo.mobile || this.userInfo.mobile == "")
            {
                // popup mode, and current path is not login
                if (document.getElementById("loginPopup") == null && 
                    window.location.href.substring(window.location.href.length - '#/login'.length) != '#/login' &&
                    window.location.href.indexOf('#/login?') < 0) {
                    createComponent(Login, {
                        on: {
                            loginSuccess() {
                                window.location.reload();
                            },
                        },
                    });
                }

                return;
            }

            (async () => {
                let productList = null;
                let totalPrice = null;
                let res = null;

                if(true)
                {
                    res = await this.axios.shop.get('/InternetMall/doscene.do', {
                        price: parseFloat(this.price),
                        shopId: this.shopInfo.supplierInfoId,
                    });
                    if(res.statusCode != 200)
                    {
                        return this.Toast(res.msg)
                    }
                    productList = res.data.productList;
                    totalPrice = res.data.sum;
                }
                
                else
                {
                    productList = [
                        {
                            "sId": null,
                            "pId": 110866,
                            "specificationId": 149092,
                            "specificationName": "默认规格",
                            "num": 200,
                            "pIdCode": null,
                            "pName": "现场买单",
                            "pNowPrice": 0.1,
                            "pWeight": 0.0,
                            "pStock": 99999999,
                            "pPic_1": "/attached/image/shop/2240/20230331/1680245927749.jpg",
                            "checked": false,
                            "ifSale": 0,
                            "sDeleteFlag": 0,
                            "pPostageMode": 0,
                            "pPostageFixedPrice": 0.0,
                            "pSpecificationFlag": 0,
                            "pSpecificationTable": null,
                            "sSpecFlag": 0,
                            "sSpecModel": null,
                            "originalPrice": 0.0,
                            "customerServiceNote": null,
                            "customerNote": null,
                            "distributionMode": 0
                        }
                    ]
                }
                //
                res = await this.axios.shop.post(
                    '/InternetMall/doSubmitOrder.do',
                    {
                        oNote: '',
                        oAddress: {
                            aName: '自提',
                            aAddressCity: '自提',
                            chooseAddress: '自提',
                            aAddressDatail: '自提',
                            aMobile: this.userInfo.mobile,
                        },
                        oProductList: productList,
                        ifShoppingCar: 0,
                        expectDeliveryTime: '',
                        transportationMode: 3,
                        couponIdList: [],
                    }
                );
                if(res.statusCode != 200)
                {
                    return this.Toast(res.msg)
                }
                const orderId = res.data;

                //
                digitalCardPay.call(this, 
                    orderId,
                    totalPrice,
                );
            })().catch(e => {
                this.Toast(`支付异常, ${e.toString()}`);
            })
        },
    },
}
</script>

<style lang="scss" scoped>
//
.buyNowMain {
    z-index: 1990;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    background-color: rgba(0, 0, 0, 0.7);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: $fontSizeContent;
    line-height: 2em;
}

.frame {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(3.75rem * 0.85);
    height: calc(3.75rem * 0.85 / 690 * 730);
    background: url('https://shop.ziubao.com/yingqiyuPro/ziubaoShopInner/nianhuo_static/static/images/buyNowBg.png');
    background-size: cover;

    .shopName {
        width: 2.4rem;
        font-size: 0.15rem;
        font-weight: 400;
        color: #333333;
        margin-top: 1.08rem;
        overflow: auto;
        white-space: nowrap;
        text-align: center;
    }

    .pricePrompt {
        width: 1.8rem;
        font-size: 0.14rem;
        font-weight: 400;
        color: #e99f0b;
        margin-top: 0.3rem;
        text-align: left;
    }

    .priceInputWrapper {
        width: 2rem;
        margin-top: 0.1rem;
        background: #ffffff;
        border: 1px solid #e99f0b;
        border-radius: 0.2rem;
        display: flex;
        align-items: center;
        height: 0.41rem;

        input {
            min-width: 0;
            flex-grow: 1;
            margin: 0 0.11rem;
            border: solid 0 #ffffff;
            height: 0.41rem;
            line-height: 0.41rem;
            &:focus {
                border: solid 0 #ffffff;
            }
        }

        .divider {
            flex-shrink: 0;
            height: 1.5em;
            width: 1px;
            height: 0.24rem;
            background: #e99f0b;
        }

        .clearText {
            flex-shrink: 0;
            font-size: 0.14rem;
            font-weight: 400;
            color: #e99f0b;
            margin: 0 0.11rem;
        }
    }

    .payButton {
        margin-top: 0.4rem;
        width: 2.2rem;
        height: 0.35rem;
        background: linear-gradient(90deg, #279cfc, #1e6ffc);
        border-radius: 0.18rem;
    }
}
</style>